import React from 'react';
import styles from './ChoiseCard.module.scss';

const ChoiseCard = ({ children, onClick, isSelected }) => {
  return (
    <div className={styles.cardBorder} onClick={onClick}>
      <div className={`${styles.cardContent} ${isSelected ? styles.selected : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default ChoiseCard;